module.exports = __webpack_public_path__ + "static/thanks-hero-a62e24af34fde4c6160157d003b0487d.svg";